// @ts-nocheck
export { DocumentSignatureComponent } from './document-signature.component'
